import { Container } from 'components/Container/Container'
import { useVendorDetailsContext } from '../Providers/ContextProvider'
import { BTN_TXT } from 'constants/txt'
import { BREADCRUMBS } from '../../constants'
import { FC, PropsWithChildren } from 'react'
import { safeString } from '../../../../../helper/common'

const ContractDetailsContainer: FC<PropsWithChildren> = ({ children }) => {
  const vendorDetailsContext = useVendorDetailsContext()

  const { details } = vendorDetailsContext.state

  const title = details?.uuid
    ? safeString(details?.name || details.business_name)
    : BTN_TXT.VENDOR_CREATION

  return (
    <Container title={title} breadcrumbs={BREADCRUMBS(title)}>
      {children}
    </Container>
  )
}

export default ContractDetailsContainer
